import { Stack, Typography } from '@mui/material'
import { Icons } from 'utoniq-ui'

import { useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'

type GachaMembershipTagProps = {
  type: 'allMembership' | 'planOnly'
}

export const GachaMembershipTag: Organism<GachaMembershipTagProps> = ({
  type,
}) => {
  const { t } = useTranslation('gachaDetail')
  return (
    <OrganismFrame>
      <Stack spacing={1} direction="row" alignItems="center">
        <Icons.MembersOnly fontSize="small" sx={{ color: 'primary.main' }} />
        <Typography variant="subtitle1" color="primary.main">
          {t(`${type}Label`)}
        </Typography>
      </Stack>
    </OrganismFrame>
  )
}
